import React from 'react'
import styled from 'styled-components'


export const Styling = styled.div`
    width: 100%;
    padding:2rem;
    position: sticky;
    bottom: 0;
    left:0;
    z-index: 100000;
    color:var(--white);
    backdrop-filter: blur(10px);
    text-align: center;
    font-size: 1.4rem;

    @media only screen and (min-width: 1024px) {
        font-size: 2rem;
    }



    &:before{
        content:"";
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background:red;
        z-index: -1;
        opacity: 0.7;
    }
`